import { offers as offersQuery, page as pageQuery } from '@data/queries';
import { Container, Stack, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import sanity from '@utils/sanity';
import { ReactElement } from 'react';
import { OfferProps } from 'src/@types/offer';
import { PageProps } from 'src/@types/page';
import Routes from 'src/routes';
import { Newsletter } from 'src/sections/newsletter';
import { OfferItemList } from 'src/sections/offers';
import { Page } from '../../src/components';
import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from '../../src/config';
import Layout from '../../src/layouts';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    paddingTop: HEADER_DESKTOP_HEIGHT,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  offers: OfferProps[];
  page: PageProps;
};

export default function OffersPage({ offers, page }: Props) {
  return (
    <Page seo={page.seo}>
      <RootStyle>
        <Container sx={{ mb: { xs: 8, md: 10 } }}>
          <Stack
            spacing={3}
            sx={{
              mt: { xs: 8, md: 10 },

              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Typography variant="h2" component="h1">Aktuelle kampanjer</Typography>
            {/* <Typography sx={{ color: 'text.secondary' }}>
              Vi har jobbet for lønnsomme og fremtidsrettede løsninger innen elektro i over 20 år. <br />Det er ikke tilfeldig at vi i dag er blant de fremste elektroinstallatørene i Bergen.
            </Typography> */}
          </Stack>

          <OfferItemList offers={offers} />
        </Container>

        <Newsletter />
      </RootStyle>
    </Page>
  );
}

// ----------------------------------------------------------------------

OffersPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

// ----------------------------------------------------------------------

export const getStaticProps = async () => {
  const offers = await sanity.fetch(offersQuery(10));
  const page = await sanity.fetch(pageQuery, { slug: Routes.offers });

  return {
    props: { offers, page },
  };
};
